import { useHandler } from "@/hooks";
import { useRefInputStore } from "@/state/stores";

export function useInputFocus() {
  const textareaRef = useRefInputStore(({ inputRef }) => inputRef);

  const focusInput = useHandler(() => {
    if (!textareaRef.current) {
      return;
    }
    textareaRef.current.focus();
  });

  return focusInput;
}
